import React, { Component } from "react";
import axios from "axios";
import { baseURL } from "../helpers/globalConstants";

class DetailedInvoiceRequest extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: null,
			message: "",
			loading: false,
			order_id: this.props.order_id,
			email: "",
			emailError: "",
		};
	}

	handleEmailChange = (e) => {
		this.setState({
			email: e.target.value,
			emailError: "",
		});
	};

	validateEmail = (email) => {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return regex.test(email);
	};

	handleRequest = () => {
		const { email } = this.state;

		// Simple email validation
		if (!email) {
			this.setState({ emailError: "Please enter your email address" });
			return;
		}

		if (!this.validateEmail(email)) {
			this.setState({ emailError: "Please enter a valid email address" });
			return;
		}

		this.setState({ loading: true });

		// Using axios with the correct URL format and email as query param
		axios
			.get(
				`${baseURL}orders/${
					this.state.order_id
				}/detailed-invoice?email=${encodeURIComponent(email)}`
			)
			.then((response) => {
				// console.log(response);
				// Check if the response has a status key indicating failure
				if (response.data.status === "fail") {
					let message = response?.data?.message?.includes(
						"Email Verification Failed"
					)
						? "Email Verification Failed"
						: "Request Failed. Try again.";
					this.setState({
						status: "error",
						message: message,
						loading: false,
					});
				} else {
					this.setState({
						status: "success",
						message: `Your receipt for Order #${this.state.order_id} has been successfully sent to ${email}.`,
						loading: false,
					});
				}
			})
			.catch((error) => {
				this.setState({
					status: "error",
					message: `Failed to send receipt for Order #${this.state.order_id}. Please try again.`,
					loading: false,
				});
			});
	};

	render() {
		const { status, message, loading, order_id, email, emailError } =
			this.state;

		return (
			<div style={styles.container}>
				<div
					style={{
						...styles.card,
						...(status && styles.expandedCard),
						...(status === "success" && styles.successCard),
						...(status === "error" && styles.errorCard),
					}}
				>
					{/* Header Section */}
					<h1 style={styles.title}>Request Receipt</h1>
					<p style={styles.description}>
						Get a Receipt for your Order #{order_id} sent directly to
						your email.
					</p>
					<div style={styles.orderInfo}>
						<span style={styles.orderLabel}>Order ID:</span>
						<span style={styles.orderValue}>#{order_id}</span>
					</div>

					{/* Email Input Field */}
					{!status || status === "error" ? (
						<div style={styles.emailContainer}>
							<label style={styles.emailLabel}>
								Email Address <span style={styles.required}>*</span>
							</label>
							<input
								type="email"
								value={email}
								onChange={this.handleEmailChange}
								placeholder="Enter your email address"
								style={styles.emailInput}
								disabled={loading}
								required
							/>
							<p style={{ ...styles.emailNote, fontWeight: "bold" }}>
								Email address should match the email on the order
							</p>
							{emailError && (
								<p style={styles.errorText}>{emailError}</p>
							)}
						</div>
					) : null}

					{/* Divider shown only when there's a status */}
					{status && <div style={styles.divider}></div>}

					{/* Result Section (shown conditionally) */}
					{status && (
						<div style={styles.resultSection}>
							{/* Removed the success/error label here */}

							<div style={styles.messageContent}>
								<div style={styles.iconContainer}>
									<div
										style={{
											...styles.iconCircle,
											backgroundColor:
												status === "success"
													? "rgba(16, 185, 129, 0.1)"
													: "rgba(239, 68, 68, 0.1)",
											color:
												status === "success"
													? "#10b981"
													: "#ef4444",
										}}
									>
										{status === "success" ? "✓" : "✕"}
									</div>
								</div>
								<p style={styles.messageText}>{message}</p>
							</div>

							{status === "success" && (
								<div style={styles.infoBox}>
									<div style={styles.infoIcon}>ℹ️</div>
									<p style={styles.infoText}>
										Please check your inbox. The Receipt may
										take a few minutes to arrive.
									</p>
								</div>
							)}
						</div>
					)}

					{/* Button Section */}
					<div style={styles.buttonContainer}>
						{status === "error" ? (
							<button
								style={styles.retryButton}
								onClick={this.handleRequest}
								disabled={loading}
							>
								{loading ? (
									<div style={styles.loaderContainer}>
										<div
											style={{
												...styles.loader,
												borderTopColor: "#ef4444",
											}}
										></div>
										<span style={styles.loaderText}>
											Trying Again...
										</span>
									</div>
								) : (
									"Try Again"
								)}
							</button>
						) : (
							<button
								style={
									loading
										? {
												...styles.button,
												...styles.buttonDisabled,
										  }
										: status === "success"
										? {
												...styles.button,
												...styles.successButton,
										  }
										: styles.button
								}
								onClick={this.handleRequest}
								disabled={loading || status === "success"}
							>
								{loading ? (
									<div style={styles.loaderContainer}>
										<div style={styles.loader}></div>
										<span style={styles.loaderText}>
											Processing...
										</span>
									</div>
								) : status === "success" ? (
									"Receipt Requested ✓"
								) : (
									"Request Receipt"
								)}
							</button>
						)}
					</div>
				</div>
			</div>
		);
	}
}

const styles = {
	container: {
		fontFamily: "Inter, sans-serif",
		background: "#f9fafb",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "100vh",
		margin: 0,
		color: "#374151",
		flexDirection: "column",
		padding: "0rem",
	},
	card: {
		background: "white",
		padding: "2rem",
		borderRadius: "10px",
		boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
		textAlign: "center",
		width: "90%",
		maxWidth: "450px",
		transition: "all 0.3s ease",
	},
	expandedCard: {
		boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
	},
	successCard: {
		borderTop: "4px solid #10b981",
	},
	errorCard: {
		borderTop: "4px solid #ef4444",
	},
	title: {
		fontSize: "1.5rem",
		marginBottom: "1rem",
	},
	description: {
		fontSize: "1rem",
		color: "#6b7280",
		marginBottom: "1.5rem",
		lineHeight: "1.5",
	},
	orderInfo: {
		backgroundColor: "#f3f4f6",
		padding: "0.75rem 1rem",
		borderRadius: "8px",
		marginBottom: "1.5rem",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
	orderLabel: {
		fontWeight: "500",
		color: "#4b5563",
	},
	orderValue: {
		fontWeight: "600",
		color: "#000000", // Changed from #3b82f6 to black
	},
	button: {
		background: "#000000", // Changed from #3b82f6 to black
		color: "white",
		border: "none",
		padding: "0.75rem 1.5rem",
		borderRadius: "5px",
		cursor: "pointer",
		fontSize: "1rem",
		transition: "all 0.2s ease",
		boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)", // Updated shadow color
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		minWidth: "160px",
		fontWeight: "500",
		letterSpacing: "0.5px",
	},
	buttonDisabled: {
		background: "#94a3b8",
		cursor: "not-allowed",
		boxShadow: "none",
	},
	loaderContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	loader: {
		width: "20px",
		height: "20px",
		border: "3px solid rgba(255, 255, 255, 0.3)",
		borderRadius: "50%",
		borderTopColor: "#fff",
		animation: "spin_de 1s ease-in-out infinite",
		marginRight: "8px",
	},
	loaderText: {
		fontSize: "0.9rem",
	},
	resultCard: {
		marginTop: "1.5rem",
		background: "white",
		padding: "1.5rem",
		borderRadius: "10px",
		boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
		width: "90%",
		maxWidth: "450px",
		animation: "fadeIn_de 0.3s ease",
		position: "relative",
		overflow: "hidden",
		transition: "all 0.3s ease",
	},

	messageContent: {
		display: "flex",
		alignItems: "center",
		marginBottom: "1rem",
		padding: "0.5rem 0",
	},

	iconContainer: {
		marginRight: "1rem",
		paddingTop: "0.25rem",
	},

	iconCircle: {
		width: "36px",
		height: "36px",
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "1.25rem",
		fontWeight: "bold",
		lineHeight: 1, // Added to ensure vertical centering
	},

	messageText: {
		fontSize: "1rem",
		lineHeight: "1.6",
		color: "#374151",
		margin: 0,
		flex: 1,
		textAlign: "left",
	},

	infoBox: {
		display: "flex",
		alignItems: "flex-start",
		backgroundColor: "rgba(0, 0, 0, 0.05)", // Changed from blue to black
		padding: "0.75rem",
		borderRadius: "8px",
		marginTop: "1rem",
		border: "1px solid rgba(0, 0, 0, 0.2)", // Changed from blue to black
	},

	infoIcon: {
		marginRight: "0.75rem",
		fontSize: "1rem",
	},

	infoText: {
		fontSize: "0.85rem",
		color: "#4b5563",
		margin: 0,
		textAlign: "left",
		flex: 1,
	},

	retryButton: {
		backgroundColor: "white",
		color: "#ef4444",
		border: "1px solid #ef4444",
		borderRadius: "5px",
		padding: "0.75rem 1.5rem",
		fontSize: "0.95rem",
		fontWeight: "500",
		cursor: "pointer",
		transition: "all 0.2s ease",
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		minWidth: "160px",
	},
	divider: {
		height: "1px",
		backgroundColor: "#e5e7eb",
		margin: "1.5rem 0",
		width: "100%",
	},

	resultSection: {
		animation: "fadeIn_de 0.4s ease",
		marginBottom: "1.5rem",
	},

	buttonContainer: {
		marginTop: "1rem",
	},

	// Adding a new style for the success button state
	successButton: {
		cursor: "default", // Remove pointer cursor
		boxShadow: "none", // Remove shadow for a more static appearance
		opacity: 0.9, // Slightly reduce opacity to indicate it's not clickable
	},

	// Email input styles
	emailContainer: {
		marginBottom: "1.5rem",
		width: "100%",
		textAlign: "left",
	},
	emailLabel: {
		display: "block",
		marginBottom: "0.5rem",
		fontSize: "0.95rem",
		fontWeight: "500",
		color: "#4b5563",
	},
	required: {
		color: "#ef4444",
	},
	emailInput: {
		width: "100%",
		padding: "0.75rem",
		fontSize: "1rem",
		borderRadius: "5px",
		border: "1px solid #d1d5db",
		backgroundColor: "#fff",
		boxSizing: "border-box",
		transition: "border-color 0.2s ease",
	},
	emailInputError: {
		borderColor: "#ef4444",
	},
	errorText: {
		color: "#ef4444",
		fontSize: "0.85rem",
		marginTop: "0.5rem",
	},
};

// Add the keyframes for animations
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `
@keyframes spin_de {
  to { transform: rotate(360deg); }
}
@keyframes fadeIn_de {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}
`;
document.head.appendChild(styleSheet);

export default DetailedInvoiceRequest;
